<template>
  <aside 
    class="fixed inset-y-0 left-0 z-50 bg-white shadow-lg transform transition-all duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0"
    :class="[
      isOpen ? 'translate-x-0' : '-translate-x-full',
      collapsed ? 'w-16' : 'w-64'
    ]"
  >
    <div class="flex flex-col h-full">
      <!-- Sidebar Header -->
      <SidebarHeader 
        :collapsed="collapsed"
        @toggle-collapse="$emit('toggle-collapse')"
      />

      <!-- Sidebar Menu -->
      <SidebarMenu 
        :menu-items="menuItems"
        :collapsed="collapsed"
      />

      <!-- Sidebar Footer -->
      <SidebarFooter 
        :collapsed="collapsed"
        :user-name="userName"
        :user-role="userRole"
        :user-avatar="userAvatar"
        @logout="$emit('logout')"
      />
    </div>
  </aside>
</template>

<script setup lang="ts">
import SidebarHeader from './SidebarHeader.vue'
import SidebarMenu from './SidebarMenu.vue'
import SidebarFooter from './SidebarFooter.vue'
import type { MenuItem } from '@/composables/useMenuPermissions'

interface Props {
  isOpen: boolean
  collapsed: boolean
  menuItems: MenuItem[]
  userName: string
  userRole: string
  userAvatar: string
}

defineProps<Props>()

defineEmits<{
  'toggle-collapse': []
  logout: []
}>()
</script>
